<template>
  <div>
    <ul class="Fuell-Tabs">
      <li class="Fuell-Tabs--tab">
        <router-link
          to="/my-physical-cards"
          class="Fuell-Tabs--link"
          active-class="active"
        >
          {{$t('cards_physical_cards_section_tab')}}
        </router-link>
      </li>

      <li class="Fuell-Tabs--tab">
        <router-link
          to="/my-virtual-cards"
          class="Fuell-Tabs--link"
          active-class="active"
        >
          {{$t('cards_virtual_cards_section_tab')}}
        </router-link>
      </li>
    </ul>

    <router-view></router-view>

  </div>
</template>

<script>
export default {
  name: 'CardsIndex'

}
</script>
